// requestAnimationFrame debouncer — collapses many rapid calls into one per frame.
// Used to make slider drags smooth: rebuilds happen at 60fps max, not per keystroke.
export function rafDebounce<Args extends unknown[]>(fn: (...a: Args) => void): (...a: Args) => void {
  let pending: Args | null = null;
  let scheduled = false;
  return (...args: Args) => {
    pending = args;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      if (pending) fn(...pending);
      pending = null;
    });
  };
}
